import dayjs from '~/modules/dayjs'

export default {
  data () {
    return {
      requestOffer: {
        date: {
          start: null,
          end: null
        },
        marina: null,
        charter_type: 5
      }
    }
  },
  async created () {
    await this.$store.dispatch('data/getBoatFormData', { type: null, data: { only: ['getCharterTypes'] } })
  },
  methods: {
    openRequestOfferForm ({ marina = null, date_start = null, date_end = null }) {
      this.requestOffer.marina = marina
      if (date_start) {
        this.requestOffer.date.start = dayjs(date_start).toDate()
      } else {
        this.requestOffer.date.start = null
      }
      if (date_end) {
        this.requestOffer.date.end = dayjs(date_end).toDate()
      } else {
        this.requestOffer.date.end = null
      }
      this.$modal.show('request-boat-modal')
    }
  }
}
